<template>
    <div @click="showField" :class="getClasses()" tabindex="-1"  @keyup.esc.stop="onKeyUp" ref="rootTag">

      <div
        ref="refPublishDatepickerWrapper"
        class="field-wrap field-wrap-datepicker exclude-outside-click"
        @click="findPosition()" @keyup="onWrapperKeyUp" tabindex="0"
      >
        <span v-show="!editing" class="exclude-outside-click field-value text-hover-bg">
          <span
            class="exclude-outside-click"
            v-if="deliverable.publish_date"
          v-html="formatDate(deliverable.publish_date)"></span>
          <span class="not-set exclude-outside-click" v-else>No Date</span>
        </span>

        <div v-show="editing" class="custom-field date-pick-field" v-click-outside="outside" @keyup.stop="onKeyUp">
			      <DatePicker
			        placeholder="No Date"
			        v-model="postDate"
			        @input="dateInput"
			        @changedMonth="calendarChangedMonth"
			        :inline="true"
			        :disabled="inputsDisabled"
			        calendar-class="test-date-calendar"
			        ref="customDatepicker"
			        tabindex="0"
			        :autofocus="true"
			        v-click-outside="outside"
			        @closed="editing=false"
			      >
				    <div slot="beforeCalendarHeader" class="calender-header">
				      <b-button class="remove-dl-btn" variant="text" @click="resetDeadline">Remove Deadline</b-button>
				      <b-button class="today-btn" variant="text" @click="onToday">Today</b-button>
				    </div>
			      <div slot="calendarFooter" class="calender-footer">
								<div class="time-wrapper">
			       			      <input type="time" :id="timePickerId"  name="appt"
			       			  	v-model="postTime"
			       			  	:disabled="inputsDisabled"
			       			  	@blur="timeUpdated"
			       			  	ref="refTime"
			       			  	tabindex="1"
											@keyup.escape.stop="onKeyUp"
			       			  	/>
			       			  </div>
			      		<b-button class="today-btn" variant="text" @click="onDone" tabindex="2">Done</b-button>
  					</div>


			       </DatePicker>



        </div>
      </div>

    </div>
</template>

<script>
// import DatePicker from '@sum.cumo/vue-datepicker'
// import '@sum.cumo/vue-datepicker/dist/Datepicker.css'

import DatePicker from '../vue-datepicker/Datepicker.js'
import '../vue-datepicker/Datepicker.css'


import { mapActions, mapState } from "vuex";
import router from '../../routes'
export default {
  name: "DeliverablePublishDatePicker",
  props: {
    namespace: String,
    sortEnabledFields: Array,
    users: Array,
    showLabel: {
      type: Boolean,
      default: true
    },
    multipleTasks: {
      type: Boolean,
      default: true
    },
    taskCount: {
      type: Number,
      default: 1
    },
    rows: {
      type: Number,
      default: 10
    },
    deliverable: Object,

  },
  data() {
    return {
    	componentId: ""+Math.random() + "-" + Math.random(),
      editing: false,

      postDate: "",
      postTime: "",
      dateTimeDisabled: false,
      dateFormat: "YYYY-MM-DD HH:mm:ss",
      timeFormat: "HH:mm:ss",
      dateArray: [],
      currentYear: null,
      currentMonth: null,
      inputsDisabled: false,

      dateSelected: false,
          customField: {
	      "label": "Publish Date",
	      "value": null,
	      "updated_at": null,
	      "custom_field": 0,
	      "label_id": null,
	      "value_set": null,
	      "field_key": "publish_date",
	      "userName": null
  	},
    };
  },
  computed: {
    	...mapState({
  	  state (state) {
  	    return state[this.namespace]
  	  },
  	  allUsers (state, getters) {
  	    return getters['allUsers']
  	  },
  	  userAbilities (state, getters) {
  	    return getters['userAbilities']
  	  },
  	  allActiveUsers (state, getters) {
  	    return getters['allActiveUsers']
  	  },
  	  deliverableDetail (state, getters) {
  	    return getters[this.namespace + 'deliverableDetail']
  	  },
  	}),
    _: function() {
      return _;
    },
    postDateFormatted(){
      return this.$moment(this.postDate).format("YYYY-MM-DD");
    },
    dateIsSet(){
    	return true;
    },
    timeIsSet(){
    	return true;
    },
    addDatesButtonDisabled(){
      if(!this.dateIsSet || !this.timeIsSet || this.inputsDisabled){
        return true;
      }
      return false;
    },
    highlightedDates(){
      if(this.seriesDeliverables !== undefined){
        let that = this;
        let dates = [];
        this.seriesDeliverables.forEach(function(deliverable){
          if(deliverable.publish_date !== null){
            dates.push(
              that.$moment.utc(deliverable.publish_date).local().toDate()
            )
          }
        });
        return {dates};
      }
      return {};
    },
    timePickerId(){
      if(this.deliverableId){
        return "social-post-time-"+this.deliverableId;
      }
      return "social-post-time-multiple-dates";
    },
    utcDateArray(){
      let utcDateTimes = [];
      if(!this.dateArray.length){
        return utcDateTimes;
      }
      // let utcTime = this.$moment(this.postTime).utc().format(this.timeFormat);
      let utcTime = this.$moment(this.postTime, [this.$moment.ISO_8601, this.timeFormat]).utc().format(this.timeFormat);
      this.dateArray.forEach(function(date){
        utcDateTimes.push(date+" "+utcTime);
      });
      return utcDateTimes;
    },


  },
  components: {
    DatePicker
  },
  methods: {
    ...mapActions({
      updateFieldValue (dispatch, payload) {
        return dispatch(this.namespace + 'updateFieldValue', payload)
      },
    }),
    formatDate(theDate) {
    	let html = "";
    	if (theDate == null || theDate == "0000-00-00 00:00:00") {
    		html = "<span class='not-set'>Not set</span>";
    	} else {
    		let localDate = this.$moment.utc(theDate).local();
    		if (this.currentYear == localDate.format("YYYY")) {
    			if (this.currentMonth == localDate.format("MM") && this.currentDay == localDate.format("DD")) {
    					html = "Today " + localDate.format(" @ h:mm a");
    			} else {
    				html = localDate.format("ddd, MMM D @ h:mm a");
    			}
    		} else {
    			html = this.$moment.utc(theDate).local().format("ddd, MMM D YYYY @ h:mm a");
    		}
    	}
    	return html;
    },

    customLabel({ name }) {
      return name;
    },
    getClasses(field_type) {
      let classes = "field-wrap";
      if (field_type == "status") {
        classes = "";
      }
      return classes;
    },
    getSortingClass(fieldId) {
      let currentSortFieldId = localStorage.getItem('storedSortFieldId')
      let currentSortState = localStorage.getItem('storedSortState')
      return fieldId == currentSortFieldId ? `sort-active ${currentSortState}-${currentSortFieldId}` : ''
    },
    customDateFormat(date) {
      return this.$moment(date, "YYYY-MM-DD").format("DD MMM, YYYY");
    },
    saveDateFormat(date) {
      return this.$moment(date).format("YYYY-MM-DD");
    },

    onDone() {
    	this.editing = false
      this.dateSelected = true
      this.clickSaveDate();
    },
    onToday() {
      this.postDate = this.$moment().format("YYYY-MM-DD");
      this.postTime = this.$moment().format("H:m:s");
      this.editing = false
      this.dateSelected = true
      this.clickSaveDate();
    },
    resetDeadline() {
    	this.postDate = null;
    	this.postTime = null;
      this.editing = false
      this.dateSelected = true
      this.clickSaveDate();
    },
    clickSaveDate(){
      if(this.dateIsSet && this.timeIsSet){
        this.dispatchPublishDate();
      }
    },


    parseValue(str) {
      try {
        return JSON.parse(str);
      } catch (e) {
        return false;
      }
    },
    findPosition() {
      if (this.$refs.refPublishDatepickerWrapper.getBoundingClientRect().y > 315) {
        $(".vdp-datepicker__calendar").css({"top": "-362px", "position":"absolute"});
        	$(".vdp-datepicker__calendar").css({"left": "-70px"});

        if ($("#social-modal-overlay").length > 0) {
        	$(".vdp-datepicker__calendar").css({"left": "-200px"});
        }

      } else {
        $(".vdp-datepicker__calendar").css("top", "unset");
        $(".vdp-datepicker .calendar-footer").css({"bottom": "unset"});

      }
    },
    showField() {
    	this.$root.$emit("component::DeliverablePublishDatePicker::showing", this.componentId);
      if(typeof this.userAbilities.editMediaCall == 'undefined' || !this.userAbilities.editMediaCall || this.deliverable.permissions.viewOnly) return;

      if (this.editing && !this.dateSelected) return;
      this.editing = true;
      this.$nextTick(() => {

      	this.$refs.refTime.focus();

        // this.$refs.customDatepicker.$children[0].$emit('showCalendar')
        if (!this.dateSelected) {
          // this.$refs.customDatepicker.showCalendar();
          // this.$refs.customDatepicker.$el.querySelector("input").focus();
          // $(".cell.day.open.selected").focus();
        } else if (this.dateSelected) {
          this.dateSelected = false;
          this.editing = false;
          $("#social-modal-overlay").show();

        }
      });
    },
    getColorClass() {
      return 'badge-primary'
    },
    outside() {
      this.editing = false;
      this.dateSelected = false;
    },
    checkPosition(e) {
      setTimeout(function() {
        if($(e.target).parents('.field-value').find('.multiselect--above').length) {
          $('.user-field').addClass('has__above__multiselect');
        } else {
          $('.user-field').removeClass('has__above__multiselect');
        }
      }, 10);
      return;
    },

    hideSocialModalOverlay() {
    	$("#social-modal-overlay").hide();
    },
    showSocialModalOverlay() {
    	$("#social-modal-overlay").show();
    },

      dateInput(){

      },
      timeUpdated(){
      },
      calendarChangedMonth(month){
        let date = null;
        if(month instanceof Date){
          date = this.$moment(month);
        } else {
          date = this.$moment(month.timestamp);
        }
        this.currentMonth = date.format("MM");
        this.currentYear = date.format("YYYY");
      },
      clickAddDates(){
        if(this.dateIsSet && this.timeIsSet){
          this.dispatchPublishDate();
        }
      },
      clickCancel(){
        this.$bvModal.hide("seriesAddMultipleDates");
      },
      dispatchPublishDate(){
        let that = this;
        this.inputsDisabled = true;

        if (that.postTime == "" || that.postTime == null) {
        	that.postTime = "00:00:00";
        }


        let selection = this.saveDateFormat(that.postDate)+" "+that.postTime;


        let utc = this.$moment(selection).utc().format(this.dateFormat);
        // console.log(selection);
        // console.log(utc);
        // this.inputsDisabled = false;
        // that.dateTimeDisabled = false;
        // return;
        if (that.postDate == null) {
        		utc = null;
        }


        this.dateTimeDisabled = true;
        this.$store.dispatch(this.namespace + "updateDeliverablePublishDate", {
          id: that.deliverable.id,
          value: utc
        }).then(function(){
          that.dateTimeDisabled = false;
        	that.inputsDisabled = false;
        	that.editing = false;
        	that.$root.$emit('deliverable::updatedPublishDate');
        });


      },
      getDateListString(date){
        return this.$moment(date).format("ddd, MMM D YYYY")+" @ "+this.$moment(this.postTime, [this.$moment.ISO_8601, this.timeFormat]).format("h:mm a");
      },

		onWrapperKeyUp(e) {
			if (e.keyCode === 13) {
				this.findPosition();
			  this.editing = true;
			}
		},

      onKeyUp(e) {
      	if (e.keyCode === 27) {
      	  this.editing = false;
      	  this.dateSelected = false;
      	}
      	if (e.keyCode === 13) {
      	  this.editing = false;
      	  this.dateSelected = true;
      	  this.clickSaveDate();
      	   e.stopPropagation();
      	}
      },

      onShowing(id) {
      	if (id == this.componentId) {
      		// we are showing ourselves
      	} else {
      		// hide ourselves, because another date picker is being shown.
      		this.editing = false;
      	}
      }
    },
    created(){
	      let localPublishDate = this.$moment.utc(this.deliverable.publish_date).local().format(this.dateFormat);
	      if(localPublishDate != "Invalid date"){
	        let localPublishArray = localPublishDate.split(" ");
	        this.postTime = localPublishArray[1];
	      	this.postDate = this.customDateFormat(localPublishDate);;
	      } else {
	        this.postTime = "00:00:00"
	        this.postDate = null;
	      }
    },

  mounted() {
    let self = this;
    if(this.isMobile()) {
      $('.custom-datepicker').on('blur', function() {
        $(this).parents('.vdp-datepicker').hide();
      })
    }
    this.$root.$on("component::DeliverablePublishDatePicker::showing", this.onShowing);
  },
  destroyed() {
    this.$root.$off("component::DeliverablePublishDatePicker::showing", this.onShowing);
  },

  watch: {
  	editing: {
  	  handler: async function (val, oldVal) {
  	  	if (val) {
  	  		this.hideSocialModalOverlay();
  	  	} else {
  	  			this.showSocialModalOverlay();
  	  	}
				}
			}
  }


};
</script>

<style>
</style>
